import { useMemo } from 'react';
import { ErrorBoundary } from '~/components/Tools';

import { withRouteLevelIntegration } from '~/components/Integrations';
import { RequiresAuth } from '~/components/Auth';

import { DEFAULT_ERROR_FALLBACK as ErrorFallback } from '~/config/app.constants';
import { EnvironmentConfig } from 'relay-runtime/lib/store/RelayModernEnvironment';

const TESTING_APP_META = {
  appName: 'LocalTesting',
  streamName: 'LocalTesting',
};

function useTestingRoute({
  TestingApplication,
  testingRoute,
  graphqlEndpoint,
  collectorUrl,
  enableRedux,
  enableDatadog,
  isProtected,
  enableSubscription,
  environmentOptions,
}: {
  TestingApplication: () => JSX.Element;
  testingRoute: string;
  graphqlEndpoint?: string;
  collectorUrl?: string;
  enableRedux?: boolean;
  enableDatadog: boolean;
  enableSubscription?: boolean;
  isProtected: boolean;
  environmentOptions?: EnvironmentConfig;
}) {
  return useMemo(() => {
    const Component = withRouteLevelIntegration({
      ...TESTING_APP_META,
      graphqlEndpoint,
      collectorUrl,
      enableRedux,
      enableDatadog,
      enableSubscription,
      environmentOptions,
    })(TestingApplication);

    return {
      path: testingRoute,
      element: (
        <ErrorBoundary fallback={ErrorFallback}>
          {isProtected ? (
            <RequiresAuth>
              <Component />
            </RequiresAuth>
          ) : (
            <Component />
          )}
        </ErrorBoundary>
      ),
    };
  }, [
    TestingApplication,
    collectorUrl,
    enableDatadog,
    enableRedux,
    enableSubscription,
    environmentOptions,
    graphqlEndpoint,
    isProtected,
    testingRoute,
  ]);
}

export default useTestingRoute;
